// Parses an imported numeric cell to a number. Accepts an optional sign and a leading/trailing dot
// (".5", "5.", "+8", "-3"), matching lengthParser's grammar; rejects commas (ambiguous decimal vs
// thousands separator) and scientific/hex/binary/octal forms.
const DECIMAL = /^[+-]?(\d+\.?\d*|\.\d+)$/;

/** Parse a numeric cell to a number, or null if it isn't a clean decimal. Negatives are allowed
 *  here (sign is validated separately so the user gets a "must be positive" message, not "not a
 *  number"). Commas are rejected (see DECIMAL) — there is no thousands-grouping fast path. */
export function parseImportNumber(raw: unknown): number | null {
  const s = String(raw ?? '').trim();
  if (s === '' || !DECIMAL.test(s)) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
}
